import * as React from 'react';
import { ClickTracker } from 'bernie-analytics';
import { LocalizedText } from 'bernie-l10n';
import { UitkScrim, UitkScrimType } from 'uitk-react-scrim';
import { UitkButtonSize, UitkPrimaryFloatingButton } from 'uitk-react-button';

export interface SearchFormBottomSectionProps {
  buttonRef?: any;
}

const UitkPrimaryFloatingButtonTracked = ClickTracker(UitkPrimaryFloatingButton);

export const SearchFormBottomSection: React.FunctionComponent<SearchFormBottomSectionProps> = ({ buttonRef }) => (
  <UitkScrim type={UitkScrimType.BUTTON}>
    <UitkPrimaryFloatingButtonTracked
      data-stid="submit-hotel-filters"
      domRef={buttonRef}
      type="submit"
      isFullWidth={true}
      size={UitkButtonSize.LARGE}
      text={<LocalizedText message="hotels.searchResults.filtersDialog.submitButton.label" />}
      rfrr="FilterControlDone"
      linkName="done search filters dialog"
    />
  </UitkScrim>
);

SearchFormBottomSection.displayName = 'SearchFormBottomSection';
